var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-page"},[(!_vm.loading)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.activityInfo.mapStyle.fnModule.activityDesc.activityDesc)}}):_vm._e(),(_vm.showBack)?_c('div',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }